/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperial`)
};

const es_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperial`)
};

const de_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperial`)
};

const nl_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperiaal`)
};

const fr_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impérial`)
};

const it_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperiale`)
};

const pt_br2_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperial`)
};

const pt_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imperial`)
};

const ja_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インペリアル法`)
};

const zh_bmi_imperial = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英制`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_imperial = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_imperial(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_imperial", locale)
	if (locale === "en") return en_bmi_imperial(inputs)
	if (locale === "es") return es_bmi_imperial(inputs)
	if (locale === "de") return de_bmi_imperial(inputs)
	if (locale === "nl") return nl_bmi_imperial(inputs)
	if (locale === "fr") return fr_bmi_imperial(inputs)
	if (locale === "it") return it_bmi_imperial(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_imperial(inputs)
	if (locale === "pt") return pt_bmi_imperial(inputs)
	if (locale === "ja") return ja_bmi_imperial(inputs)
	return zh_bmi_imperial(inputs)
};